import styles from './ClientInfoItem.module.css'
import {useDispatch, useSelector} from "react-redux";
import {
    ReduxStateInt,
    setAdminState,
    setAuthLogin,
    setAuthToken,
    setLoginState,
    setOrderData
} from "../../Reducer/GlobalReducer";
import InputItem from "../../FormTemplate/InputItem/InputItem";
import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import {PaymentInt} from "../Payment/Payment";
import WaitLoader from "../../WaitLoader/WaitLoader";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import InputItemLight from "../../FormTemplate/InputItemLight/InputItemLight";
import {useNavigate} from "react-router-dom";

interface CompleteOrderDataInt
{
    orderId:string
    sessionId?:string
    senderId?:string
}
interface ClientInfoInt
{
    user: string
    pass?: string
    existUser:boolean
    contactData?: {
        phone?:string
        eMail?:string
    }
    textUser?:string
    textPass?:string

}
interface ClientContactDataInt
{
    orderId: string
    sessionId:string
    phone?:string
    eMail?:string
}



export default function ClientInfoItem()
{
    const errorLineRef = useRef<ErrorLineItemRef>(null)
    const completeOrderData = useRef<CompleteOrderDataInt>()
    const [ldrCompleteOrder,rsCompleteOrder,exCompleteOrder] = useApiQuery("/sell/sim/order/complete","post",completeOrderData);

    const clientContactData = useRef<ClientContactDataInt>()
    const [ldrClientContact,rsClientContact,exClientContact] = useApiQuery("/sell/sim/order/contact","post",clientContactData);
    const [clientContactUpload,setClientContactUpload] = useState(false)
    const mainCont = useRef<HTMLDivElement>(null)

    const [mode, setMode] = useState(0)
    const navigate = useNavigate();

    const dataLogin = useRef<{
        user:string
        token: string
        pass: string
        capt : string
    }>()
    const [ldrLogin,rsLogin,exLogin] = useApiQuery("/auth/login","post",dataLogin);
    const [authTokenLight,setAuthTokenLight] = useState<string|undefined>()

    const dispatch = useDispatch()
    const orderData = useSelector((state: ReduxStateInt) => {
        return state.orderData
    })
    const token = useSelector((state: ReduxStateInt) => {
        return state?.authToken
    })

    const [client, setClient] = useState<ClientInfoInt>()

    const [clientData, setClientData] = useState<{
        phone?:string
        eMail?:string
        isCorrect: boolean
    }>()

    useEffect(()=>{
        if(mainCont.current)mainCont.current.scrollIntoView()

    },[mainCont])

    useEffect(()=>{
        console.log("clientData",clientData)
    },[clientData])

    useEffect(()=>{
        completeOrder()
    },[orderData.orderId])

    const completeOrder = () =>{
        if(!orderData?.orderId) return
        completeOrderData.current = {
            orderId: orderData?.orderId,
            sessionId:orderData?.sessionId,
            senderId: "sim-unlim.com"
        }
        exCompleteOrder().then((e)=>{
            if(e?.success)
            {
                const payload = e?.payload
                dispatch(setOrderData({...orderData,userData: {
                        login:payload?.user,
                        pass:payload?.pass,
                        existUser: payload?.existUser
                    }}))
                setClient(payload)
                setClientData({
                    phone: payload?.contactData?.phone,
                    isCorrect: false
                })
                setAuthTokenLight(payload?.token ? payload?.token : undefined)
                return
            }
            setMode(1)
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true,5000 )

        }).catch((e)=>{
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true,5000 )
            setMode(1)
        })
    }



    const handleSendContact = () =>{

        const rgPhone = clientData?.phone ? clientData?.phone?.match((/[0-9]{10}$/ui)) : undefined
        const phone = rgPhone ? rgPhone[0] : undefined
        clientContactData.current = {
            orderId: orderData?.orderId ? orderData?.orderId : "",
            sessionId: orderData?.sessionId ? orderData?.sessionId : "",
            eMail: clientData?.eMail ? clientData?.eMail: undefined,
            phone: phone,
        }
        exClientContact().then((e)=>{
            if(e?.success)
            {
                setClientContactUpload(true)
                return
            }
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true,5000 )

        }).catch((e)=>{
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true,5000 )

        })

    }


    const normCtn = (e:string) => {
        const t = e.toString()
        const mh = t.match(/[0-9]{10}$/ui)
        if(mh) return "+7" + mh[0]
        return t

    }


    const handleLogin = () =>{
        if(!authTokenLight || !orderData?.userData?.login) return
        dataLogin.current = {
            token: authTokenLight,
            user: orderData?.userData?.login,
            pass: "xxxxxxxxxx",
            capt: "xxxx"

        }
        exLogin().then((e)=>{
            if(e?.success){

                dispatch(setAdminState(false))
                dispatch(setLoginState(true))


                dispatch(setAuthToken(e?.payload?.token))

                dispatch(setAuthLogin(e?.payload?.login))
                setAuthTokenLight(undefined)
                navigate('/lk/client/contact')
                return


            }
            setAuthTokenLight(undefined)
        })

    }


    const buildLogin = ()=>{
        console.log("AuthToken", authTokenLight)
        if(! authTokenLight) return null
        return (
            <div className={styles.lgCont}>
                <div className={styles.lgButton}
                    onClick={handleLogin}
                >Войти</div>
            </div>
        )
    }


    const buildUserInfo = () =>{
        if(client?.existUser ) return null
        if(clientContactUpload)
        return (
            <>
                <div>Данные отправлены, спасибо за заказ</div>
                <div>Вы можете отслеживать заказ в личном кабинете</div>
            </>
        )
        return (
            <>
                <div  className={styles.textOne}>Просим оставить любые Ваши контактные данные, при возникновении вопросов с доставкой или другими вопросами,
                    они помогут нашему  сотруднику оперативно связаться с Вами, почта также используется для восстановления пароля и информирования о статусах заказа</div>
                <div className={styles.ucCont}>
                    <InputItem
                        title={"Телефон"}
                        val={clientData?.phone ? clientData?.phone : ""}
                        placeHolder={"XXXXXXXXXX"}
                        info={"Номер телефона"}
                        mode={"ei"}
                        type={"number"}
                        regExp={/(((\+7)|(8)|(^))9[0-9]{9}$)|(^$)/ui}
                        onPreProcess={(e)=>normCtn(e)}
                        onCorrect={(e)=>{
                            if(e?.length)setClientData({...clientData,phone: normCtn(e),isCorrect: true})

                        }}
                        onBlur={(e)=>{
                            if(! e?.length)
                            {
                                setClientData({...clientData,phone: "",isCorrect: !!clientData?.eMail})
                                return

                            }
                            setClientData({...clientData,phone: e.trim(),isCorrect: true})
                        }}


                    ></InputItem>
                    <InputItem
                        title={"eMail"}
                        val={clientData?.eMail ? clientData?.eMail : ""}
                        info={"Электронная почта"}
//                        placeHolder={""}
                        mode={"ei"}
                        regExp={/(^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$)|(^$)/ui}
                        onCorrect={(e)=>{
                            if(e?.length)setClientData({...clientData,eMail: (e),isCorrect: true})

                        }}

                        onBlur={(e)=>{
                            if(! e?.length)
                            {
                                setClientData({...clientData,eMail: "",isCorrect: !!clientData?.phone})
                                return

                            }
                            setClientData({...clientData,eMail: e.trim(),isCorrect: true})
                        }}
                    />
                    <div className={styles.erCont}><ErrorLineItem ref={errorLineRef} ></ErrorLineItem></div>
                    <div className={styles.btnCont}>
                        <button type="button" className = {["btn btn-face"].join(' ')}
                                disabled={!clientData?.isCorrect}
                                onClick={()=>handleSendContact()}
                        ><span className={ styles.btnBlink}>отправить</span></button>
                        <WaitLoader loading={ldrClientContact} api={rsClientContact} onlyLoading={true}>
                        </WaitLoader>

                    </div>

                </div>
            </>

        )
    }
    if(mode === 1)
        return(
            <div className={styles.mainCont} ref={mainCont}>
                <div className={styles.lkDivError}>Не можем завершить заказ номер {orderData?.orderId}.</div>
                <div>Просим связаться по номеру +79993046060</div>
            </div>
        )

    const buildCallLater = () =>{

        const phone = clientData?.phone ? clientData?.phone :  `+7${orderData?.mnpData?.ctn}`
        if(orderData?.regMode === 10)
        {
            return(
                <div className={styles.warCall}>
                    В ближайшее время Вам поступит звонок на номер {phone} от менеджера, для согласования
                    и подтверждения процедуры перехода, в выходные дни звонок может поступить с задержкой. Наши номера [ +7-999-304-6060, +7-903-931-0502 ]
                </div>
            )
        }

        return null
    }



    const lkText = client?.existUser ? "Ваш личный кабинет уже существует" : "Вам создан личный кабинет"
    const mnpNotify = orderData?.regMode === 10 && !orderData?.mnpData?.sameOper ? true : false
    return(
        <div className={styles.mainCont} ref={mainCont}>

            <WaitLoader loading={ldrCompleteOrder} api={rsCompleteOrder} onlyLoading={true}>
                <div className={styles.orComTitle}>Поздравляем Ваш заказ создан</div>
                <div>Номер заказа : <span>{orderData?.orderId}</span></div>

                <div className={styles.lkDiv}>{lkText}</div>
                <div className={styles.lkDiv}>В личном кабинете Вам будет предоставлен трэк отслеживания заказа и многое другое...</div>
                <div className={styles.lkDiv}>!! Внимание: личный кабинет на этом сайте !!</div>
                <div className={[styles.pCont, styles.clData].join(' ')}>
                    <div className={styles.lgCont}>
                        <InputItemLight
                            title={client?.textUser}
                            val={client?.user ? client?.user : ""}
                            placeHolder={"XXXXXXXXXX"}
                            mode={""}
                            classTitle={styles.tlInput}
                            titleColNumber={8}

                        />
                        <InputItemLight
                            title={client?.textPass}
                            val={client?.pass ? client?.pass : ""}
                            placeHolder={"XXXXXXXXXX"}
                            mode={""}
                            classTitle={styles.tlInput}
                            titleColNumber={8}

                        />

                    </div>
                    {buildLogin()}
                </div>
                {buildCallLater()}
                {!ldrCompleteOrder && buildUserInfo()}
                {mnpNotify &&
                    <>
                        <div className={styles.mnpNotifyTemp}>
                            Согасно принятой оферте, в случае, если Вы отказались от процедуры MNP по собственному желанию,
                            когда процесс уже был согласован и был выделен «временный» номер, обязанность закрыть временный номер и
                            сопутствующие расходы по закрытию номера ложатся на Вас.
                        </div>
                        <div className={styles.mnpNotify}>
                            В процессе перехода Вам будет звонить текущий оператор с предложением отменить процесс МНП, предлагая подключить скидку на Вашем текущем тарифе, мотивируя Вас отказаться от процесса портации.
                            Имейте в виду, что это предожение будет временным и оператор может его в любой момент отменить, а повторно оформить заявку на портацию можно будет
                            только через 60 дней.
                        </div>


                    </>
                }


            </WaitLoader>



        </div>
    )
}